import IconSun from "@/assets/icons-svg/icon-sun.svg";
import IconMoon from "@/assets/icons-svg/icon-moon.svg";

export const switchs = [
  {
    icon: IconMoon,
    label: "Dark",
  },
  {
    icon: IconSun,
    label: "Light",
  },
];
